<template>
  <v-select
      prepend-inner-icon="category"
      :items="items"
      :item-text="'name'"
      :item-value="'id'"
      v-model="item"
      :label="$t('delivery.product.labels.categories')"
      :loading="loading"
      :error="hasInputErrors('category')"
      :error-messages="getInputErrors('category')"
      color="secondary"
      item-color="secondary"
      :rules="isRequired ? required : []"
      :hide-details="hideDetails"
      :solo="solo"
      :clearable="clearable"
      :multiple="multiple"
  >
    <template v-if="selectAll && multiple" v-slot:prepend-item>
      <v-list-item ripple @click="toggleSelectAll">
        <v-list-item-action>
          <v-checkbox
              :input-value="selectAllChecked"
              :indeterminate="selectAllIndeterminate"
              color="secondary"
              hide-details
              readonly
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('delivery.productCategory.actions.selectAll') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import ProductCategoryProvider from "../../providers/ProductCategoryProvider"

export default {
  name: "ProductCategoryCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    hideDetails: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    isRequired:  {type: Boolean, default: true},
    multiple: {type: Boolean, default: false},
    selectAll: {type: Boolean, default: false},
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectedValues() {
      return Array.isArray(this.item) ? this.item : []
    },
    selectedIds() {
      return this.selectedValues.map(category => {
        if (typeof category === 'object') return category.id || category._id
        return category
      }).filter(categoryId => !!categoryId)
    },
    selectAllChecked() {
      return this.items.length > 0 && this.selectedIds.length === this.items.length
    },
    selectAllIndeterminate() {
      return this.selectedIds.length > 0 && !this.selectAllChecked
    },
    returnObject() {
      return this.$attrs['return-object'] !== undefined && this.$attrs['return-object'] !== false
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch(){
      this.loading= true
      ProductCategoryProvider.fetchProductCategory().then(r => {
        this.items = r.data.fetchProductCategory
      }).catch(err => console.error(err))
          .finally(()=> this.loading = false)
    },
    toggleSelectAll() {
      if (this.selectAllChecked) {
        this.item = []
      } else {
        this.item = this.returnObject ? this.items.slice() : this.items.map(item => item.id)
      }
    }

  }
}
</script>

<style scoped>

</style>
